import { useSearchParams } from 'react-router-dom';
import { Tabs } from 'antd';
import PredictionUpdatePage from '@/pages/PredictionUpdate';
import PerceptionRefreshPanel from '@/pages/PerceptionRefresh';

/** 当前页签记在 ``?type=``，刷新和从明细页返回时停在原页签。 */
const TYPE_PARAM = 'type';
type DataUpdateType = 'prediction' | 'perception';

/**
 * 「数据更新」页：按任务类型分两个页签。
 *
 * - 预测数据（PR_DATA）：原数据更新页，原样渲染；
 * - 感知数据（PE_DATA）：感知数据刷写的版本列表。
 *
 * 两类数据的版本规则、列表字段、创建参数都不同，分页签各自独立，互不影响；共用页面权限
 * ``menu:prediction:update``。
 */
export default function DataUpdatePage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeKey: DataUpdateType = searchParams.get(TYPE_PARAM) === 'perception' ? 'perception' : 'prediction';

  return (
    <Tabs
      activeKey={activeKey}
      onChange={(key) => {
        const next = new URLSearchParams(searchParams);
        if (key === 'prediction') {
          next.delete(TYPE_PARAM);
        } else {
          next.set(TYPE_PARAM, key);
        }
        setSearchParams(next, { replace: true });
      }}
      destroyOnHidden
      style={{ padding: '0 16px' }}
      items={[
        { key: 'prediction', label: '预测数据（PR_DATA）', children: <PredictionUpdatePage /> },
        { key: 'perception', label: '感知数据（PE_DATA）', children: <PerceptionRefreshPanel /> },
      ]}
    />
  );
}
